//#region ../../node_modules/@turf/helpers/dist/esm/index.js
var e = 6371008.8;
e * 100, e * 100, 360 / (2 * Math.PI), e * 3.28084, e * 39.37, e / 1e3, e / 1e3, e / 1609.344, e * 1e3, e * 1e3, e / 1852, e * 1.0936;
function t(e, t, n = {}) {
	let r = { type: "Feature" };
	return (n.id === 0 || n.id) && (r.id = n.id), n.bbox && (r.bbox = n.bbox), r.properties = t || {}, r.geometry = e, r;
}
function n(e, n, r = {}) {
	if (!e) throw Error("coordinates is required");
	if (!Array.isArray(e)) throw Error("coordinates must be an Array");
	if (e.length < 2) throw Error("coordinates must be at least 2 numbers long");
	if (!i(e[0]) || !i(e[1])) throw Error("coordinates must contain numbers");
	return t({
		type: "Point",
		coordinates: e
	}, n, r);
}
function r(e, n, r = {}) {
	return t({
		type: "MultiPoint",
		coordinates: e
	}, n, r);
}
function i(e) {
	return !isNaN(e) && e !== null && !Array.isArray(e);
}
//#endregion
export { n, r as t };
